import React, { useContext, useEffect } from "react";
import CheckoutHeader from "../layouts/header/CheckoutHeader";
import { AuthUserContext } from "../context/AuthUserContext";
import CheckoutMain from "../layouts/main/CheckoutMain";

const Checkout = () => {
  const { fetchUserData, authTokens, userProfile, logoutUser } =
    useContext(AuthUserContext);

  useEffect(() => {
    if (!authTokens) {
      logoutUser();
      return;
    } else if (!userProfile) {
      fetchUserData();
    }
  }, []);
  return (
    <div>
      <CheckoutHeader />
      {userProfile && <CheckoutMain />}
    </div>
  );
};

export default Checkout;
